/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetPaymentInfoErrorResponse, GetPaymentInfoResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncountersPayment = (encounterId: number, signal?: AbortSignal) => {
  return api<GetPaymentInfoResponse>({
    url: `/api/encounters/${encounterId}/payment`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersPaymentQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/payment`] as const;
};

export const getGetEncountersPaymentQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersPayment>>,
  TError = GetPaymentInfoErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPayment>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersPaymentQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersPayment>>> = ({ signal }) =>
    getEncountersPayment(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersPayment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersPaymentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersPayment>>
>;
export type GetEncountersPaymentQueryError = GetPaymentInfoErrorResponse;

export function useGetEncountersPayment<
  TData = Awaited<ReturnType<typeof getEncountersPayment>>,
  TError = GetPaymentInfoErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPayment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersPayment>>,
          TError,
          Awaited<ReturnType<typeof getEncountersPayment>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersPayment<
  TData = Awaited<ReturnType<typeof getEncountersPayment>>,
  TError = GetPaymentInfoErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPayment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersPayment>>,
          TError,
          Awaited<ReturnType<typeof getEncountersPayment>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersPayment<
  TData = Awaited<ReturnType<typeof getEncountersPayment>>,
  TError = GetPaymentInfoErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPayment>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersPayment<
  TData = Awaited<ReturnType<typeof getEncountersPayment>>,
  TError = GetPaymentInfoErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPayment>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersPaymentQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
